import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation} from 'react-router-dom';
import Colors from '../utilities/Colors';
import { d2gAvg, getGeoName, d2gRound, getNYCAVG } from '../utilities/Utilities';
// Import the functions directly from the store
import { Histogram } from '../charts/Histogram';
import { useData } from '../../data/DataContext';
import { onHoverHistogram, useGlobalActiveGeography, useGlobalActiveIndicator, useGlobalDBModuleId, useGlobalModuleId, useGlobalActiveDBModuleId, useGlobalActiveRGModuleId, useGlobalActiveModuleId, useGlobalActiveSTModuleId, useGlobalActivePage, onSetActivePage } from '../../data/StatusStore';
import * as turf from 'turf';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import ExportModal from '../inputs/ExportModal';

interface DataItem {
    id: string;
    value: any; // Consider specifying a more detailed type here
}

export interface MainHistogramProps {
  dataGeo: any;
  dataNYC: any;
  dataCD: any;
  dataBoro?: any;
  histMax: any;
  histNA: any;
  histLength: any; 
  chartId: string;
  groupedModules?: any;
  unGroupedModules?: any;
  activeIndicatorOverride: string | null;
  colorClassOverride: string | null;
  auxOptions?: any;
  context: string;
}

export const MainHistogram: React.FC<MainHistogramProps> = ({ 
    dataGeo, dataNYC, dataCD, dataBoro, histMax, histNA, histLength, chartId, groupedModules, unGroupedModules, activeIndicatorOverride, colorClassOverride, auxOptions, context
}) => {
    /*console.log("A020425 histMax", histMax);
    console.log("A020425 histNA", histNA);
    console.log("A020425 histLength", histLength);
    console.log("A020425 dataGeo", dataGeo);
    
    console.log("A020425 chartId", chartId);*/
    const activeIndicator = useGlobalActiveIndicator();
    const activeGeography = useGlobalActiveGeography();
    const globalDBModuleId = useGlobalDBModuleId();
    const globalModuleId = useGlobalModuleId();
    const globalActiveDBModuleId = useGlobalActiveDBModuleId();
    const globalActiveRGModuleId = useGlobalActiveRGModuleId();
    const globalActiveModuleId = useGlobalActiveModuleId();
    const globalActiveSTModuleId = useGlobalActiveSTModuleId();
    const activePage = useGlobalActivePage();
    const {
        geoJsonDataPUMA, geoJsonDataTract, pumaToCDRows,
        geoJsonDataNTA, geoJsonDataBoro,
        isLoadingTopology, error, dataPoint, setDataPoint, pointDataList, pointModules
    } = useData();
    /*console.log("A020425 activeIndicator", activeIndicator);
    console.log("A020425 activeGeography", activeGeography);
    console.log("A020425 globalModuleId", globalModuleId);
    console.log("A020425 globalActiveModuleId", globalActiveModuleId);
    console.log("A020425 dataPoint", dataPoint);
    console.log("A020425 pointDataList", pointDataList);
    console.log("A020425 pointModules", pointModules);
    console.log("A020425 dataGeo.meta.DISPLAY_NAME[activeIndicator]", dataGeo.meta.DISPLAY_NAME[activeIndicator]);*/

    const [isModalVisible, setModalVisible] = useState(false);
    const [intersectedPts, setIntersectedPts] = useState<any>([]);

    const openModal = () => setModalVisible(true);
    const closeModal = () => setModalVisible(false);

    const height = '135';
    const width = '100%'; //calc(100% - 40px)';
    const paddingLeft = '0px'; 
    const paddingRight = '0px'; 

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        
        if (dataPoint && !dataGeo?.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]) {
            console.log("A022625 dataPoint", dataPoint);
            console.log("A022625 activeIndicator", activeIndicator);
            console.log("A022625 dataGeo.meta.DISPLAY_NAME", dataGeo.meta.DISPLAY_NAME);
            if (dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]){
                if (!dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]].intersected || !dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]].intersected[activeGeography]) {
                    //console.log("AA020425  dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]", dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]);
                    //console.log("AA020425  activeGeography", activeGeography);
                    let tempGeoJSON = geoJsonDataTract;
                    if (activeGeography === "PUMA" || activeGeography === "CD") {
                        tempGeoJSON = geoJsonDataPUMA;
                    } else if (activeGeography === "Tract") {
                        tempGeoJSON = geoJsonDataTract;
                    } else if (activeGeography === "NTA") {
                        tempGeoJSON = geoJsonDataNTA;
                    } else if (activeGeography === "Boro") {
                        tempGeoJSON = geoJsonDataBoro;
                    }
                    //console.log("AA020425 tempGeoJSON", tempGeoJSON);
                    let points = dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]];
                    let polys = tempGeoJSON;
                    console.log("AA022625 points", points);
                    console.log("AA022625 polys", polys);
                    if (points && polys) {
                        let intersected = getPointsInPolys(points.data, polys);
                        //console.log("AA020425 intersected", intersected);
                        setIntersectedPts(intersected);
                        let _dataPoint = JSON.parse(JSON.stringify(dataPoint));
                        if (_dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]["intersected"]){
                            _dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]["intersected"][activeGeography] = intersected;
                        }else{
                            _dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]["intersected"] = {};
                            _dataPoint[dataGeo.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]]["intersected"][activeGeography] = intersected;
                        }
                        //console.log("AA020425 _dataPoint", _dataPoint)
                        console.log("F040725 _dataPoint", _dataPoint);
                        setDataPoint(_dataPoint);
                    }
                //console.log("AA020425 dataGeo?.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]", dataGeo?.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
                //console.log("AA020425 unGroupedModules[activePage === explorer ? globalActiveModuleId : globalActiveDBModuleId][0].Sort.Color", unGroupedModules[activePage === "explorer" ? globalActiveModuleId : globalActiveDBModuleId][0].Sort.Color);
                }
            }
        }
    }, [dataPoint, activeGeography, activeIndicator]);

    
    const getPointsInPolys = (points: any, polys: any) => {
        const result: Record<string, number> = {}; // Object to store counts by GEOID20
        let type = "points"
        if (points.type && points.type === 'FeatureCollection') {
            type = "polygon";
        }
        //console.log("AA022625 points", points);
        //console.log("AA022625 type", type);
        if (type === "points") {
            points.forEach((point: any) => {
                let pt = turf.point([point.latitude, point.longitude]); // Ensure correct coordinate order
                polys.features.forEach((feature: any) => {
                    const geoid = feature.properties?.GEOID20; // Ensure GEOID20 exists
                    if (!geoid || !pt || !feature?.geometry) return; // Skip invalid data
        
                    if (booleanPointInPolygon(pt, feature)) {
                        result[geoid] = (result[geoid] || 0) + 1; // Increment count
                    } else {
                        result[geoid] = result[geoid] || 0; // Ensure key exists even if count is 0
                    }
                });
            });
        } else {
            //console.log("AA022625 points", points);
            points.features.forEach((point: any) => {
                //console.log("AA022625 point", point);
                let pt = turf.centroid(point); // Use centroid if point is a polygon
                polys.features.forEach((feature: any) => {
                    const geoid = feature.properties?.GEOID20; // Ensure GEOID20 exists
                    if (!geoid || !pt || !feature?.geometry) return; // Skip invalid data
        
                    if (booleanPointInPolygon(pt, feature)) {
                        result[geoid] = (result[geoid] || 0) + 1; // Increment count
                    } else {
                        result[geoid] = result[geoid] || 0; // Ensure key exists even if count is 0
                    }
                });
            });
        }
        //console.log("AA022625 result", result);
        // Convert object to sorted array
        const sortedArray = Object.entries(result)
            .map(([id, value]) => ({ id, value })) // Convert to array format
            .sort((a, b) => a.value - b.value); // Sort by value (ascending)
    
        // Determine maxValue
        const maxValue = sortedArray.length > 0 ? sortedArray[sortedArray.length - 1].value : 0;
    
        // Create indexed object with ranking
        const indexedObject: Record<string, { value: number; index: number }> = {};
        sortedArray.forEach(({ id, value }, index) => {
            indexedObject[id] = { value, index };
        });
    
        return { sortedArray, indexedObject, maxValue };
    };
    
    // Normalize boroAvgs: { names: {1:{value:'Bronx',index:0},...}, values:{1:{value:62.39,index:0},...} }
    const boroByName = useMemo(() => {
        console.log("A050426 dataBoro", dataBoro);
        if (!dataBoro?.keyIndexDataArray) return null;
        let cd_count_lookup:any = {
            "Bronx": 12,
            "Brooklyn": 18,
            "Manhattan": 12,
            "Queens": 14,
            "Staten Island": 3
        };
        let boroAvgs = {
            values: dataBoro.keyIndexDataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator],
            names: dataBoro.keyIndexDataArray["GEO_DISPLAY_NAME"],
        }
        if (!boroAvgs || !boroAvgs.names || !boroAvgs.values) return null;
        const result: Record<any, { value: any; valueNormalized: any; index: number }> = {};
        Object.keys(boroAvgs.names).forEach((k) => {
            const nameObj = boroAvgs.names[k];
            const valObj = boroAvgs.values[k];
            if (!nameObj || !valObj) return;
            const name = String(nameObj.value);
            const value = Number(valObj.value);
            const valueNormalized = Number(valObj.value / cd_count_lookup[name]); // normalize by CD count
            //const valueNormalized = value; //Number(valObj.value / cd_count_lookup[name]); // normalize by CD count
            const index = Number(valObj.index);
            console.log("A050426 name, value, valueNormalized, index", name, value, valueNormalized, index);
            if (name && Number.isFinite(value) && Number.isFinite(index)) {
                result[name] = { value, valueNormalized, index };
            }else{
                result[name] = { value: "N/A", valueNormalized: "N/A", index };
            }
        });
        console.log("A050426 boroByName > result", result);
        return result as any;
    }, [dataBoro, activeIndicatorOverride, activeIndicator]);


    //console.log("A112724 globalDBModuleId", globalDBModuleId);
    //console.log("A112724 globalModuleId", globalModuleId);
    //console.log("A040425 dataNYC", dataNYC);
    //console.log("A040425 dataGeo", dataGeo);
    //console.log("A112724 groupedModules", groupedModules);
    //console.log("A112724 unGroupedModules", unGroupedModules);
    //console.log("A112724 unGroupedModules[activePage === explorer ? globalModuleId : globalDBModuleId]", unGroupedModules[activePage === "explorer" ? globalModuleId : globalDBModuleId]);
    //console.log("AAA112724 unGroupedModules[activePage === explorer ? globalModuleId : globalDBModuleId][0].Sort.Color", unGroupedModules[activePage === "explorer" ? globalModuleId : globalDBModuleId][0].Sort.Color);
    //console.log("A112724 globalDBModuleId", globalDBModuleId);
    //console.log("083024 activeIndicator", activeIndicator);
    //console.log("083024 dataGeo?.meta?.DISPLAY_NAME", dataGeo?.meta?.DISPLAY_NAME);
    //console.log("083024 dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]", dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);

    const changePage = (newPage: string) => {
    const newSearchParams = new URLSearchParams(location.search);
    //newSearchParams.set('page', newPage); // Update the 'page' parameter
    onSetActivePage(newPage);
    // Construct the URL with parameters in the correct order
    const paramsOrder = ['page', 'lat', 'lng', 'zoom', 'selectedId', 'activeGeography', 'activeIndicator', 'bivariateIndicator'];
    const orderedParams = new URLSearchParams();
    
    paramsOrder.forEach(param => {
        const value = newSearchParams.get(param);
        if (value) orderedParams.set(param, value);
    });

    navigate(`/?${orderedParams.toString()}`, { replace: true });
    
    };

    if (!unGroupedModules) {
        return null;
    }
    console.log("A011926 dataNYC", dataNYC);
    console.log("A050426 boroByName", boroByName);
    console.log("011326 activeIndicatorOverride", activeIndicatorOverride);
    console.log("011326 activeIndicator", activeIndicator);
    console.log("011326 dataBoro.meta.DESCRIPTOR", dataBoro?.meta?.DESCRIPTOR);
    console.log("A050426 ", 
        (boroByName && boroByName["Bronx"]) 
            ? ` | BX:  ${d2gRound(boroByName["Bronx"].value, { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | BK:  ${d2gRound(boroByName["Brooklyn"].value, { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | MN:  ${d2gRound(boroByName["Manhattan"].value, { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | QN:  ${d2gRound(boroByName["Queens"].value, { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | SI:  ${d2gRound(boroByName["Staten Island"].value, { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })} `
            : null );
    /*console.log("011326 activeIndicatorOverride", activeIndicatorOverride);
    console.log("011326 activeIndicator", activeIndicator);
    console.log("011326 colorClassOverride", colorClassOverride);
    console.log("011326 activePage", activePage);
    console.log("011326 globalActiveRGModuleId", globalActiveRGModuleId);
    console.log("011326 globalActiveModuleId", globalActiveModuleId);
    console.log("011326 globalActiveSTModuleId", globalActiveSTModuleId);
    console.log("011326 unGroupedModules", unGroupedModules);
    console.log("011326 ", !activeIndicatorOverride
                        ? unGroupedModules[activePage !== "dashboard" 
                            ? activePage === "stories" 
                                ? globalActiveSTModuleId 
                                : activePage === "rg" 
                                    ? globalActiveRGModuleId 
                                    : globalActiveModuleId 
                            : globalActiveDBModuleId][0].Sort.Color
                        : colorClassOverride
    );
    console.log("123025 dataGeo", dataGeo);
    console.log("B123025 dataBoro", dataBoro);
    console.log("B123025 boroByName", boroByName);
      console.log("B011226", dataGeo?.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
    */
      /*console.log("I042625 activeIndicator", activeIndicatorOverride);
    console.log("I042625 activeIndicator", activeIndicator);
    console.log("C050625 ...", dataGeo?.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] === "X" 
        ? dataGeo?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] 
        : dataNYC?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
    console.log("C050625 ...", dataGeo?.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] === "X" 
        ? dataGeo?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] 
        : dataNYC?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);*/
    //console.log("A041225 dataGeo?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]", dataGeo?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
    //console.log("A041225 dataGeo?.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]", dataGeo?.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
    //console.log("A041225 activeIndicatorOverride ? activeIndicatorOverride : activeIndicator", activeIndicatorOverride ? activeIndicatorOverride : activeIndicator);
    //console.log("activeIndicator", activeIndicator);
    //console.log("dataGeo?.meta.NOTES[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]", dataGeo?.meta.NOTES[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
    //console.log("A031225 unGroupedModules(activePage === 'explorer' || activePage === 'stories') ? globalActiveModuleId : globalActiveDBModuleId][0].Sort.Color", unGroupedModules[(activePage === 'explorer' || activePage === 'stories') ? globalActiveModuleId : globalActiveDBModuleId][0].Sort.Color);
    //console.log("A031225 activePage", activePage);
    //console.log("A031225 globalActiveModuleId", globalActiveModuleId);
    //console.log("A031225 globalActiveDBModuleId", globalActiveDBModuleId);
    //console.log("A031225 unGroupedModules", unGroupedModules);
    /*console.log("B051425 ---------------------------------------------------------");
    console.log("B051425 ---------------------------------------------------------");
    console.log("B051425 activeIndicatorOverride", activeIndicatorOverride);
    console.log("B051425 unGroupedModules", unGroupedModules);
    console.log("B051425 activePage", activePage); 
    console.log("B051425 globalActiveSTModuleId", globalActiveSTModuleId); 
    console.log("B051425 globalActiveRGModuleId", globalActiveRGModuleId); 
    console.log("B051425 globalActiveDBModuleId", globalActiveDBModuleId); 
    console.log("B051425 colorClassOverride", colorClassOverride); 
    console.log("B051425 ",!activeIndicatorOverride
                        ? unGroupedModules[activePage !== "dashboard" 
                            ? activePage === "stories" 
                                ? globalActiveSTModuleId 
                                : activePage === "rg" 
                                    ? globalActiveRGModuleId 
                                    : globalActiveModuleId 
                            : globalActiveDBModuleId]
                        : colorClassOverride)*/
    //let _value = dataGeo.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] !== "X" && dataGeo.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] !== "$X"
    //                ? "value"
    //                : "valueNormalized";
    const _value = "value";

    //let _isCount = 
    console.log("012026 dataGeo", dataGeo);
    console.log("012026 dataBoro", dataBoro);
    console.log("012026 boroByName", boroByName);
    console.log("012026 _value", _value);
    //console.log("012026 dataNYC.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator][0].value ", dataNYC.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator][0].value );
    console.log("012026 dataCD.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]", dataCD.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]);
    const currentIndicator = activeIndicatorOverride ? activeIndicatorOverride : activeIndicator;
    const nycAvg = getNYCAVG(activeIndicatorOverride, activeIndicator, dataGeo, dataNYC, dataCD);
    const histogramColorClass = colorClassOverride
        || Colors.resolveModuleColor(
            unGroupedModules, currentIndicator, activePage,
            globalActiveModuleId, globalActiveDBModuleId,
            globalActiveRGModuleId, globalActiveSTModuleId
        );
    return (
        <>  
            <div 
            id='mainHistogramContext'
            style={{ 
                padding:"25px",
                paddingBottom:"0px",
                display: "inline-flex",
                height:'calc(100% - 135px)',
                justifyContent: 'space-between',
                width: '100%',
            }}>
                <div style={{  
                        width: '100%'
                    }}>
                    <div style={{ 
                        //fontWeight:"bold",
                        //height:'100%',
                        paddingRight:'5px',
                        //maxHeight:'65px',
                        width: '100%', 
                        overflowY: "hidden", 
                        overflowX: "hidden", 
                        display: "inline-flex",
                        //flexDirection: "column",
                    }}>
                        <div
                            style={{
                            fontSize: "24px",
                            lineHeight: "30px",
                            color: "#231f20",
                            overflowY: "hidden",
                            //height: "65px",
                            }}
                        >{dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] ? dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator].split("(")[0] : ""}</div>
                        { /*activePage === "rg"
                        ? <div
                            style={{
                            fontSize: "12px",
                            lineHeight: "28px",
                            paddingLeft:"5px",
                            color: "#5a5a5a",
                            }}
                        >{`(${dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator].split("(")[1]}`}</div> 
                        : null
                        */}  
                    </div> 
                    <div id="geoRaceContext" style={{ fontSize:"12px", width: '100%', paddingTop:"5px", paddingBottom:"10px", lineHeight:"14px"}}>
                        {
                        activePage === "rg" 
                            ? <span>by <b>{`${dataGeo?.meta.rg_label[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}`}</b> residents</span> 
                            : null} by <b>{
                            (activeGeography === "CD" && pumaToCDRows) 
                                ? pumaToCDRows.hasOwnProperty(activeIndicatorOverride ? activeIndicatorOverride : activeIndicator)
                                    ? "Community District Equivalent (PUMA)"
                                    : getGeoName(activeGeography)
                                : getGeoName(activeGeography)
                            }</b></div>
                    <div 
                        id="descriptionContext"
                        style={{ 
                            fontSize:"13px",
                            fontWeight:"normal", 
                            width: '100%', 
                            marginBottom:"10px", 
                            lineHeight:"13px",
                            overflow: "hidden",
                            //height: "calc(100% - 125px)",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "6", /* Number of lines to show before truncating */
                            WebkitBoxOrient: "vertical",
                        }}>
                            {dataGeo?.meta.NOTES[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]?.split("(")[0]}<span
                                                        style={{ 
                                                            fontSize:"12px",
                                                            fontWeight:"normal",
                                                            color:"#9E9C9C",
                                                        }}
                                                    >
                                                        {dataGeo?.meta.NOTES[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]?.split("(")[1] ? `(${dataGeo?.meta.NOTES[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator].split("(")[1]}` : ""}
                                                        </span>
                        </div>
                    <div id="sourceContext" style={{ fontSize:"12px", width: '100%', lineHeight:"13px"}}>
                        {nycAvg == null ? null : (
                        <span style={{ 
                            color:"#000",
                        }}
                        >{d2gAvg(nycAvg)}: {
                            d2gRound(
                                nycAvg,
                                { DESCRIPTOR: dataNYC.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] }
                            )
                        }</span>
                        )}
                        <span style={{ 
                            color:"#000",
                            //fontWeight:"bold",
                        }}
                        >{(boroByName && boroByName["Bronx"]) 
                            ? ` | BX:  ${d2gRound(boroByName["Bronx"][_value], { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | BK:  ${d2gRound(boroByName["Brooklyn"][_value], { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | MN:  ${d2gRound(boroByName["Manhattan"][_value], { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | QN:  ${d2gRound(boroByName["Queens"][_value], { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })}  | SI:  ${d2gRound(boroByName["Staten Island"][_value], { DESCRIPTOR: dataBoro.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] })} `
                            : null }</span>
                        <span style={{
                            paddingLeft:"15px",
                        }}><br/></span>
                        <span style={{ 
                            color:"#9E9C9C",
                            //fontWeight:"bold",
                        }}
                        >Source: <a className="source-link" href={`${dataGeo?.meta["SOURCE URL"][activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}`} target='_blank'>{`${dataGeo?.meta["SOURCE NAME"][activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}`}</a></span>
                        <span style={{
                            paddingLeft:"15px",
                        }}><br/></span>
                        <span
                            style={{
                                fontSize:"12px",
                                width: '100%', 
                                lineHeight:"14px",
                                color:"#9E9C9C",
                            }}
                        >Year: {dataGeo?.meta["YEAR"][activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}</span>
                        {/*<span
                            onClick={() => {
                                alert(`this will bring up a modal displaying the indicator(${activeIndicator}'s) metadata`)
                            }}
                            style={{
                                fontStyle:"italic",
                                textDecoration:"underline",
                                textUnderlineOffset:"1px",
                                //fontWeight:"bold",
                                cursor: "pointer",
                            }}
                        ><br/>more info...</span>*/}
                        </div>
                </div>
                <div id='legendExport'>
                    {!activeIndicatorOverride 
                        ? <div style={{
                            width: "100%",
                            fontSize: "12px",
                            paddingRight:"2.5px",
                            paddingLeft:"2.5px",
                            lineHeight:"16px",
                            height:"20px",
                            cursor: "pointer",
                        }}
                        className='compare-button'
                        onClick={() => {
                            changePage('compare');
                            //alert(`this will bring you to the /compare page with the current indicator (${activeIndicator}) and geography (${activeGeography}) selected`)
                        }}
                        >compare</div>
                    : null}
                    {!activeIndicatorOverride 
                        ? <div style={{
                            width: "100%",
                            minWidth: "77px",
                            fontSize: "12px",
                            paddingRight:"2.5px",
                            paddingLeft:"2.5px",
                            marginTop:"5px",
                            lineHeight:"16px",
                            height:"20px",
                            cursor: "pointer",
                        }}
                        className='compare-button'
                        onClick={() => {
                            //alert(`this will begin an export`)
                            openModal();
                        }}
                    >export/share</div>
                    : null}
                    <ExportModal 
                        title={dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] ? dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator].split("(")[0] : ""} 
                        displayName={dataGeo?.meta.DISPLAY_NAME[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]} 
                        year={dataGeo?.meta.YEAR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]} 
                        isVisible={isModalVisible} 
                        onClose={closeModal} 
                        dataGeo={dataGeo}
                        activeIndicator={activeIndicatorOverride ? activeIndicatorOverride : activeIndicator}
                        bivariateIndicator={null}
                    />
                    </div>
            </div>
            <div style={{ 
                //paddingLeft:"25px",
                //paddingRight:"25px",
                //position:"relative",
                width: "calc(100% - 50px)",
                position:"relative",
                left: context === "module" ? "37.5px" : "25px",
            }}>
                <Histogram 
                    key={`main_hist_${activeIndicatorOverride ? activeIndicatorOverride : activeIndicator}`}
                    dataArray={dataGeo?.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] ? dataGeo?.dataArray[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] : intersectedPts?.sortedArray?.length > 0 ? intersectedPts.sortedArray : []}
                    histMax={histMax[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] ? histMax[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] : intersectedPts.maxValue ? intersectedPts.maxValue : 0}
                    histNA={histNA[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] ? histNA[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] : 0} 
                    histLength={histLength[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] ? histLength[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] : intersectedPts?.sortedArray?.length > 0 ? intersectedPts?.sortedArray?.length : 0 } 
                    chartId={activeIndicatorOverride ? activeIndicatorOverride : activeIndicator}
                    height={height}
                    width={width}
                    paddingLeft={paddingLeft}
                    paddingRight={paddingRight}
                    tooltips={true}
                    //colorClass={dataGeo?.meta["Module Color"][activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}
                    colorClass={histogramColorClass}
                    data={dataGeo}
                    indicator={activeIndicatorOverride ? activeIndicatorOverride : activeIndicator}
                    // ??? AVG
                    /*nycAvg={dataGeo?.meta.DESCRIPTOR[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] === "X" 
                        ? dataGeo?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] 
                        : dataNYC?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}*/
                    // PRECALC AVG
                    //nycAvg={dataGeo?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator] }
                    // CD AVG
                    nycAvg={
                            getNYCAVG(activeIndicatorOverride, activeIndicator, dataGeo, dataNYC, dataCD)
                        }
                    boroByName={boroByName}
                    // NYC AS AVG
                    //nycAvg={dataNYC?.meta.avg[activeIndicatorOverride ? activeIndicatorOverride : activeIndicator]}
                    auxOptions={auxOptions}
                    useCase={"main"}
                />
            </div>
        </>
    );
};
